export default "__VITE_ASSET__CQs$USbb__"